import { render, staticRenderFns } from "./blessingBagList.vue?vue&type=template&id=16bcf948&scoped=true&"
import script from "./blessingBag.ts?vue&type=script&lang=ts&"
export * from "./blessingBag.ts?vue&type=script&lang=ts&"
import style0 from "./blessingBagList.vue?vue&type=style&index=0&id=16bcf948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bcf948",
  null
  
)

export default component.exports